module.exports = __webpack_public_path__ + "static/LovedOnes-97581370ed0440a8c6b2f805f58f939f.png";